import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

export enum DialogResult {
  NEGATIVE,
  POSITIVE,
  NEUTRAL
}
@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
  selector: 'app-generic-dialog',
  templateUrl: 'generic-dialog.popup.html',
  styleUrls: ['../../styles/common.scss']
})
export class GenericDialogPopup {
  data = inject(MAT_DIALOG_DATA);
  private dialogRef = inject<MatDialogRef<GenericDialogPopup>>(MatDialogRef);


  title = '';
  message = '';
  htmlContent = '';
  positiveButtonText = '';
  negativeButtonText = '';
  neutralButtonText = '';
  isPositivePrompt: boolean;

  constructor() {
    const data = this.data;


    this.title = data.title;
    this.message = data.message;
    this.htmlContent = data.htmlContent;
    this.positiveButtonText = data.positiveButtonText;
    this.negativeButtonText = data.negativeButtonText;
    this.neutralButtonText = data.neutralButtonText;
    this.isPositivePrompt = data.isPositivePrompt;
  }

  onNegativeClick() {
    this.dialogRef.close(DialogResult.NEGATIVE);
  }

  onPositiveClick() {
    this.dialogRef.close(DialogResult.POSITIVE);
  }

  onNeutralClick() {
    this.dialogRef.close(DialogResult.NEUTRAL);
  }
}
